<section class="container-fluid banner-img d-flex justify-content-center align-items-center">
  <img class="bottomLogo" src="assets/images/white-logo.svg" alt="">
    <div class="row py-5">
      <div class="col-lg-12 col-md-12 col-sm-12 wow bounceInUp">
        <!-- form card login -->
        <div class="card login-card">
          <div class="card-header login-header">
            <div class="font-semi-bold pb-2">Super Admin Login</div>
            <div class="font-regular">Enter your detail below.</div>
          </div>
          <div class="card-body">
            <form class="form" (ngSubmit)="login(loginForm.value)" [formGroup]="loginForm" autocomplete="off">
              <div class="form-group mb-2">
                <label class="font-medium py-2" for="email">Email Address</label>
                <input type="email" class="form-control font-medium input-field"
                  [ngClass]="{ 'is-invalid': submitted && f['email'].errors}" (keydown.space)="$event.preventDefault()"
                  formControlName="email" placeholder="Enter your email address" noSpaces/>
                <div *ngIf=" submitted && f['email'].errors" class="invalid-feedback">
                  <div *ngIf="submitted && f['email'].errors['required']"> {{validationErrorMessage.email}} </div>
                </div>
                <div *ngIf="submitted && f['email'].errors" class="invalid-feedback">
                  <div *ngIf="submitted && (f['email'].errors['email'] || f['email'].errors['pattern'] )">
                    {{validationErrorMessage.validEmail}}</div>
                </div>
              </div>
              <div class="form-group">
                <label class="font-medium py-2" for="password">Password</label>
                <div class="icon-relative">
                  <input [type]="hide ? 'password' : 'text'" class="form-control font-medium input-field"
                    formControlName="password" (keydown.space)="$event.preventDefault()" noSpaces
                    [ngClass]="{ 'is-invalid': submitted && f['password'].errors }" placeholder="Enter your password" />
                  <div class="icon-absolute">
                    <mat-icon class="icon" (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </div>
                </div>
                <!-- <i class="far fa-eye icon" id="togglePassword"></i>              -->
                <div *ngIf="submitted && f['password'].errors" class="invalid-feedback"
                  [ngStyle]="{'display': submitted && f['password'].errors ? 'block': 'none' }">
                  <div *ngIf="submitted && f['password'].errors['required']">{{validationErrorMessage.password}}</div>
                </div>
              </div>
              <div class="custom-control custom-checkbox  d-flex py-2 ">
                <div class="d-flex align-items-center align-self-start w-75">
                  <input type="checkbox" class="custom-control-input" id="customCheck1" formControlName='remember'
                    [checked]="rem">
                  <span>&nbsp;</span>
                  <label class="custom-control-label py-2 font-regular" for="customCheck1">Remember me</label>
                </div>
                <div class="d-flex justify-content-end w-50 py-2 font-regular">
                  <a style="cursor: pointer; text-align: end;" class="blue text-decoration-none"
                    (click)="forgotPassword()">{{'Forgot Password?'}}</a>
                </div>
              </div>
              <div class="form-group mt-3">
                <button type="submit" class="form-control theme-button" id="btnLogin">
                  <span>Login</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  

</section>
